export default __webpack_public_path__ + "static/TaberTTD-a6108c1c9b14296a72cea681189d6857.jpg";